<template>
  <div>
    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование сотрудника" size="lg" hide-footer
             id="editModal" no-close-on-backdrop no-close-on-esc>
      <div class="d-block">

        <portal-target name="modal-dropdowns-people" multiple/>

        <b-card no-body class="mt-1">
          <b-tabs card small>
            <b-tab title="Основные данные" active>
              <InputGroupForm class="mb-1" widthPrepend="30" prepend="ФИО">
                <b-form-input type="text" placeholder="Укажите ФИО" v-model="selectedItem.fio"/>
              </InputGroupForm>

              <InputGroupForm class="mb-1" widthPrepend="30" prepend="Должность">
                <b-form-input type="text" placeholder="Укажите должность" v-model="selectedItem.post"/>
              </InputGroupForm>
              <!--<b-form-invalid-feedback :state="validValue.dolzhn">Указана пустая должность</b-form-invalid-feedback>-->

              <InputGroupForm class="mb-1" widthPrepend="30" prepend="Телефон">
                <b-input-group-append>
                  <the-mask class="px-1" style="width: 100%" type="text"
                            :mask="['+7 (###) ###-####', '+7 (###) ###-####']"
                            v-model="selectedItem.phoneNumber"
                            placeholder="+7(999) 999-9999"/>
                </b-input-group-append>
              </InputGroupForm>

              <InputGroupForm class="mb-1" widthPrepend="30" prepend="ИНН">
                <b-form-input type="text" v-model="selectedItem.inn" placeholder="Укажите ИНН"
                              @keypress="validateNumber"
                              maxLength="12"
                              aria-describedby="input-live-help input-live-feedback"/>
              </InputGroupForm>

              <InputGroupForm class="mb-1" widthPrepend="30" prepend="Email">
                <b-form-input type="email" v-model="selectedItem.email" placeholder="Укажите email"/>
              </InputGroupForm>

              <InputGroupForm class="mb-1" widthPrepend="30" prepend="Федерация">
                <FormSelectVue
                    class="w-100"
                    :options="fedList"
                    label-key="shortName"
                    value-key="id"
                    v-model="selectedItem.federationId"
                    portal-target="modal-dropdowns-people">
                </FormSelectVue>
              </InputGroupForm>
            </b-tab>
            <b-tab title="Паспортные данные">
              <b-card-text>
                <b-row>
                  <b-col>
                    <InputGroupForm class="mb-1" widthPrepend="30" prepend="Серия / Номер">
                      <b-form-input type="text" placeholder="Серия" v-model="selectedItem.serialPass"/>
                      <b-form-input type="text" placeholder="Номер" v-model="selectedItem.numberPass"/>
                    </InputGroupForm>
                  </b-col>
                  <!--                  <b-col>-->
                  <!--                    <InputGroupForm class="mb-1" widthPrepend="30" prepend="Номер">-->
                  <!--                      <b-form-input type="text" placeholder="Номер" v-model="selectedItem.numberPass"/>-->
                  <!--                    </InputGroupForm>-->
                  <!--                  </b-col>-->
                </b-row>
                <b-row>
                  <b-col>
                    <InputGroupForm class="mb-1" widthPrepend="30" prepend="Дата выдачи">
                      <b-form-datepicker v-model="selectedItem.datePass" :max="maxD" locale="ru"
                                         :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }">
                      </b-form-datepicker>
                    </InputGroupForm>
                  </b-col>
                </b-row>

                <InputGroupForm class="mb-1" widthPrepend="30" prepend="Кем выдан">
                  <b-form-textarea
                      id="textarea"
                      v-model="selectedItem.wherePass"
                      placeholder="Укажите кем выдан"
                      rows="2"
                      max-rows="3"
                  />
                </InputGroupForm>

                <InputGroupForm class="mb-1" widthPrepend="30" prepend="Адрес по прописке">
                  <b-form-textarea
                      id="textarea"
                      v-model="selectedItem.adressPass"
                      placeholder="Укажите адрес"
                      rows="2"
                      max-rows="3"
                  />
                </InputGroupForm>

              </b-card-text>
            </b-tab>
            <b-tab title="Организация">
              <b-card-text>
                <b-row>
                  <b-col sm="6">
                    <b-form-group>
                      <b-form-checkbox-group
                          v-model="selectedItem.orgList"
                          :options="orgList"
                          stacked
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab title="Виды ЕКП">
              <b-card-text>
                <b-row>
                  <b-col sm="6">
                    <b-form-group>
                      <b-form-checkbox-group
                          v-model="selectedItem.ekpTypes"
                          :options="ekpTypeList"
                          stacked
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab title="Настройки">
              <b-form-checkbox v-model="selectedItem.showInSite">
                Отображать информацию на странице Контактов
              </b-form-checkbox>
            </b-tab>
          </b-tabs>
        </b-card>
        <b-form-invalid-feedback :state="validValue.fio">Указано пустое ФИО</b-form-invalid-feedback>
        <b-form-invalid-feedback :state="validValue.phone">Указана пустой телефон</b-form-invalid-feedback>
        <b-form-invalid-feedback :state="validValue.email">Указан пустой email</b-form-invalid-feedback>
        <b-form-invalid-feedback :state="validValue.org">Укажите хотя бы одну организацию</b-form-invalid-feedback>
        <b-form-invalid-feedback id="input-live-feedback">
          Enter at least 3 letters
        </b-form-invalid-feedback>

        <div class="text-right">
          <b-button size="sm" class="mt-1 mr-1" variant="outline-primary" @click="savePeople">Сохранить</b-button>
          <b-button size="sm" class="mt-1" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import InputGroupForm from "@/components/InputGroupForm.vue"
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue"
import global from "@/utils/global";

export default {
  components: {InputGroupForm, FormSelectVue},
  props: {
    orgList: [],
    fedList: [],
    ekpTypeList: [],
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const maxDate = new Date(today)

    return {
      modalEditOpened: false,
      maxD: maxDate,
      validValue: {
        org: true,
        fio: true,
        inn: true,
        phone: true,
        email: true,
        form: true,
      },
      selectedItem: {
        id: null,
        fio: '',
        inn: '',
        post: '',
        phoneNumber: '',
        federationId: null,
        showInSite: false,
        adressPass: null,
        wherePass: null,
        serialPass: null,
        numberPass: null,
        datePass: null,
        ekpTypes: [],
        orgList: []
      },
    }
  },
  methods: {
    savePeople() {
      this.checkForm();
      if (this.validValue.form) {
        this.$emit("savePeople", this.selectedItem)
        // this.$refs.PeopleTab.save(this.selectedItem);
      }
    },
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.fio || this.selectedItem.fio === '') {
        this.validValue.fio = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.phoneNumber || this.selectedItem.phoneNumber === '') {
        this.validValue.phone = false;
        this.validValue.form = false;
      }
    },
    validateNumber(value) {
      global.validateNumber(value);
    },
    showEditDialog() {
      this.modalEditOpened = true
      this.selectedItem = JSON.parse(JSON.stringify(this.value));
    },
    closeEditDialog() {
      this.modalEditOpened = false
    }
  }
}
</script>
